import script from "./NoGoods.vue?vue&type=script&lang=ts&setup=true"
export * from "./NoGoods.vue?vue&type=script&lang=ts&setup=true"

import "./NoGoods.vue?vue&type=style&index=0&id=7f3d1800&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f3d1800"]])

export default __exports__